import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import $ from 'jquery'; // Add this import
// import { Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

function Header() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    // Initialize the carousel when component mounts
    if (isHomePage) {
      // Make sure jQuery and Bootstrap are loaded
      if (window.$ && window.$.fn.carousel) {
        $('#customCarousel1').carousel();
      }
    }
  }, [isHomePage]);

  return (
    <>
      <div className="hero_area">
        <div className="bg-box">
          <img src="./assets/images/hero-bg.jpg" alt="" />
        </div>
        
        {/* Header Section */}
        <header className="header_section" style={{padding:'0px'}}>
          <div className="container">
            <nav className="navbar navbar-expand-lg custom_nav-container" style={{padding:'0px'}}>
              <Link to='/' className="navbar-brand">
                <img src='./assets/images/logo.png' style={{height:'100px'}}/>
              </Link>

              <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className=""> </span>
              </button>

              <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav mx-auto">
                  <li className="nav-item active">
                    <Link to='/' className='nav-link'>Home <span className="sr-only">(current)</span></Link>
                  </li>
                  <li className="nav-item">
                    <Link to='/menu' className='nav-link'>Menu</Link>
                  </li>
                  <li className="nav-item">
                    <Link to='/about' className='nav-link'>About</Link>
                  </li>
                  <li className="nav-item">
                    <Link to='/book' className='nav-link'>Book Table</Link>
                  </li>
                </ul>
                <div className="user_option">
                  <Link to='' className="user_link">
                    <i className="fa fa-user" aria-hidden="true"></i>
                  </Link>
                  <Link to='#' className="cart_link">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 456.029 456.029" style={{ enableBackground: "new 0 0 456.029 456.029" }} xmlSpace="preserve">
                      {/* SVG Paths (unchanged) */}
                    </svg>
                  </Link>
                  <form className="form-inline">
                    <button className="btn my-2 my-sm-0 nav_search-btn" type="submit">
                      <i className="fa fa-search" aria-hidden="true"></i>
                    </button>
                  </form>
                  <Link to='' className="order_online">Order Online</Link>
                </div>
              </div>
            </nav>
          </div>
        </header>
        
        {/* Slider Section (Conditional Rendering) */}
        {isHomePage && (
          <section className="slider_section">
          <div id="customCarousel1" className="carousel slide" data-ride="carousel">
            <div className="carousel-inner">
              <div className="carousel-item active">
                <div className="container">
                  <div className="row">
                    <div className="col-md-7 col-lg-6">
                      <div className="detail-box">
                        <h1>Fast Food Restaurant</h1>
                        <p>
                          Doloremque, itaque aperiam facilis rerum, commodi, temporibus sapiente ad mollitia laborum quam quisquam esse error unde.
                        </p>
                        <div className="btn-box">
                          <Link to='' className="btn1">Order Now</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Additional carousel items */}
              <div className="carousel-item">
                <div className="container">
                  <div className="row">
                    <div className="col-md-7 col-lg-6">
                      <div className="detail-box">
                        <h1>Delicious Menu</h1>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod metus vel sem bibendum.
                        </p>
                        <div className="btn-box">
                          <Link to='' className="btn1">View Menu</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="carousel-item">
                <div className="container">
                  <div className="row">
                    <div className="col-md-7 col-lg-6">
                      <div className="detail-box">
                        <h1>Special Offers</h1>
                        <p>
                          Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.
                        </p>
                        <div className="btn-box">
                          <Link to='' className="btn1">Get Offers</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container">
              <ol className="carousel-indicators">
                <li data-target="#customCarousel1" data-slide-to="0" className="active"></li>
                <li data-target="#customCarousel1" data-slide-to="1"></li>
                <li data-target="#customCarousel1" data-slide-to="2"></li>
              </ol>
            </div>
          </div>
        </section>
        )}
      </div>
    </>
  );
}

export default Header;